import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  ContentChildren,
  Directive,
  ElementRef, EventEmitter,
  Input, OnChanges, OnDestroy, Output,
  QueryList, SimpleChanges,
  ViewChild
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatCardModule} from "@angular/material/card";
import {ButtonModule} from "../button/button.module";
import {LoadingModule} from "../../../../components/common/loading/loading.module";
import {TablerIconsProvider} from "angular-tabler-icons";
import {IconChevronDown, IconChevronRight} from "angular-tabler-icons/icons";
@Directive({
  standalone: true,
  selector: '[footer-main]'
})
export class FooterMainProjectionDirective {}

@Directive({
  standalone: true,
  selector: '[footer-actions]'
})
export class FooterActionsProjectionDirective {}

@Component({
  selector: 'app-card-v2',
  standalone: true,
  imports: [CommonModule, MatCardModule, ButtonModule, LoadingModule],
  templateUrl: './card-v2.component.html',
  styleUrls: [
      './card-v2.component.scss',
  ],
})
export class CardV2Component implements AfterViewInit, AfterViewChecked, OnDestroy {

  public static DEFAULT_MAX_CONTENT_HEIGHT = 50000;

  @Input() title: string;
  @Input() hideHeader = false;
  @Input() footerVisibleEventCollapsed = false;

  @Input() collapsable = false;
  @Input() collapsed = false;

  @Input() variant: 'default' | 'nested' = 'default';
  @Input() displayRefreshButton = false;

  @Input() contentMaxHeight = CardV2Component.DEFAULT_MAX_CONTENT_HEIGHT;
  @Input() contentExpanded = false;
  @Input() contentLoading = false;
  @Input() counter = -1;

  @Output() refreshEvent: EventEmitter<void> = new EventEmitter();
  @Output() collapsedChangedEvent: EventEmitter<boolean> = new EventEmitter();

  @ContentChildren(FooterMainProjectionDirective) footerMains!: QueryList<FooterMainProjectionDirective>;
  @ContentChildren(FooterActionsProjectionDirective) footerActions!: QueryList<FooterActionsProjectionDirective>;
  @ViewChild('cardContent') cardContent!: ElementRef<HTMLDivElement>;

  displayContentExpandButton = false;

  private resizeObserver?: ResizeObserver;

  private resizeListener = () => this.refreshDisplayExpandContentButton();

  ngAfterViewChecked(): void {
    this.refreshDisplayExpandContentButton();
  }

  ngAfterViewInit(): void {
    this.refreshDisplayExpandContentButton();
    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => {
        this.refreshDisplayExpandContentButton();
      });
      this.resizeObserver.observe(this.cardContent.nativeElement);
    }
  }

  ngOnDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = undefined;
    }
  }

  refreshDisplayExpandContentButton() {
    this.displayContentExpandButton = false;
    if (!this.cardContent) return;
    const el = this.cardContent.nativeElement;
    this.displayContentExpandButton = el.scrollHeight > el.clientHeight;
  }

  get defaultMaxContentHeight(): number {
    return CardV2Component.DEFAULT_MAX_CONTENT_HEIGHT;
  }
}
